// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"10675b33","239":"e3899939","453":"797bb2a1","455":"1ff8599a"}[chunkId] + ".chunk.js";
};